import { InputForm } from "../atoms/input";
import { ChatInputField } from "./chatInput";
import { ChatTopBar } from "./chatTopBar";
import { ChatBox, ChatBoxInSide } from "./chatbox";
import { PackageComp } from "./packageComp";
import { TopNavSetting } from "./topNavigationSettings";
import { TopBar } from "./topbar";
import { useState } from "react";
import { ChatBottomBar } from "./chatBottomBar";
import { VerticalLayout } from "./layout";
import { icon } from "../functions/icons";

export function CommunicationScreen({
  chatBottom,
  chats,
  chattingUser,
  currentMessage,
  setCurrentMessage,
  currentFiles,
  setCurrentFiles,
  sendChatMessage,
  goBack,
  chatData,
  handleChatArchive
}) {
  const isChatBoxDisabled = !chattingUser || !chatData || chatData.length === 0;
  return (
    <VerticalLayout className={`phone-chat ${isChatBoxDisabled ? "disabled" : ""}`} style={{ }}>
      <ChatTopBar handleChatArchive={handleChatArchive} chatData={chatData} user={chattingUser} goBack={goBack} />
      <VerticalLayout
      className="chat-layout"
        style={{ overflowY: "auto", height: "calc(100vh - 20rem)" }}
      >
      {isChatBoxDisabled ? (
          <div style={{ height:"100%", display: "flex", justifyContent:"center", alignItems:"center",  padding: "1rem", }}>
            Geen chat actief. Klik op een chat om te beginnen.
          </div>
        ) : (
          chats.map((chat, index) => (
            <ChatBoxInSide key={index} chatData={chat} />
          ))
        )}
        <div ref={chatBottom}></div>
      </VerticalLayout>{" "}
      
      <ChatBottomBar
        message={currentMessage}
        setMessage={setCurrentMessage}
        files={currentFiles}
        setFiles={setCurrentFiles}
        sendMessage={sendChatMessage}
      />
    </VerticalLayout>
  );
}
